import { useTranslation } from 'next-i18next';
import { cx } from '@emotion/css';
import { DSButton, DSSpinner } from '@stihl-design-system/components';

interface PaginationLoaderProps {
  id: string;
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
  onClickLoadMore: () => void;
  className?: string;
}

export const PaginationLoader = ({ id, hasNextPage, isFetchingNextPage, onClickLoadMore, className }: PaginationLoaderProps) => {
  const { t } = useTranslation('shared');
  return (
    hasNextPage && (
      <div className={cx('flex justify-center p-4', className)}>
        {isFetchingNextPage ? (
          <DSSpinner size="medium" data-testid={`pageLoaderSpinner-${id}`} />
        ) : (
          <DSButton data-testid={`pageLoaderButton-${id}`} variant="filled" onClick={onClickLoadMore}>
            {t('global_button_loadMore')}
          </DSButton>
        )}
      </div>
    )
  );
};
